import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';

import { AppService } from '@app/app.service';
import { AuthService } from '@app/auth/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-user-name-change',
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatInputModule,
    MatTooltipModule
],
  standalone: true,
  templateUrl: './user-name-change.component.html',
  styleUrl: './user-name-change.component.scss'
})
export class UserNameChangeComponent {

  nameForm!: FormGroup;
  user: any = null;

  constructor(
    private fb: FormBuilder, 
    private appService: AppService,
    private authService: AuthService,
    private router: Router,
  ) {

    if(!environment.allowNameChange) {
      this.router.navigate(['/account']);
      return;
    }

    this.nameForm = this.fb.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required]
    });

    this.user = this.authService.getUserFromStorage();

    if(this.user) {
      this.nameForm.patchValue({
        first_name: this.user.first_name,
        last_name: this.user.last_name
      });
    }

  }

  updateName() {

    if(this.nameForm.invalid) {
      this.appService.showSnackBar('Please fill in all required fields', 'error');
      return;
    }

    if(!this.formChanged()) {
      this.appService.showSnackBar('No changes made', 'info');
      return;
    }

    this.authService.updateUserName(this.nameForm.value).subscribe({
      next: (response) => {
        this.appService.showSnackBar(response.message, 'success');
        this.authService.setUserToStorage(response.data);
        this.router.navigate(['/account']);
      },
      error: (error) => {
        this.appService.handleError(error);
      }
    });
    
  }

  formChanged(): boolean {
    // Check if any field changed
    const firstName = this.nameForm.get('first_name')?.value;
    const lastName = this.nameForm.get('last_name')?.value;
    if (this.user) {
      return firstName !== this.user.first_name || lastName !== this.user.last_name;
    }
    return false;
  }

  goBack() {
    this.router.navigate(['/account']);
  }

}
